import script from "./UiButtonArrow.vue?vue&type=script&setup=true&lang=js"
export * from "./UiButtonArrow.vue?vue&type=script&setup=true&lang=js"

import "./UiButtonArrow.vue?vue&type=style&index=0&id=74fafab8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74fafab8"]])

export default __exports__